// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubHeader_wrapper__1f9WP","content":"SubHeader_content__36JXi","btnBack":"SubHeader_btnBack__TKxHD","line":"SubHeader_line__2lnF5"};